<template>
  <div>
    <el-dialog
      title="提示"
      v-model="visible"
      :close-on-click-modal="false"
      width="570px"
      :visible.sync="visible"
      :before-close="handleClose"
      class="saveDialog"
    >
      <div class="saveContent">
        <el-button type="success" icon="el-icon-check" class="successBtn"></el-button>
        <p>保存成功</p>
        <p>
          您的账户：
          <a href="javasciprt:;" class="colorMsg">
            <span v-if="source == '1'">申报简表</span>
            <span v-if="source == '2'">促销协议</span>
            <!-- <span v-show="sourceThree">促销协议</span>  -->
          </a>成功保存
        </p>
        <div>
          <el-button type="primary" @click="goNext(contractLocalidTwo,year)" v-if="source == '1'">下一步</el-button>
          <el-button type="primary" @click="goNextCX(contractLocalidTwo)" v-if="source == '2'">下一步</el-button>
          <el-button @click="preview(contractLocalidTwo,previewOne)">预览</el-button>
          <!-- <el-button @click="handleClose()">返回上一步</el-button> -->
          <el-button @click="goList()">返回列表</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    contractLocalidTwo: {
      type: Number,
      default: 0
    },
    source: {
      type: Number,
      default: 1
    },
    year:{
      type: Number,
      default:0
    },
    previewOne:{
      type: Number,
      default:0
    },
    params:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
      supNumber: "",
      lists: [],
      sourceOne: true, //控制申报简表显示隐藏
      sourceTwo: false, //控制采购协议显示隐藏
    };
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit("update:visible", false);
    },
    jumpTo(url, param) {
      // 跳转路径
      sessionStorage.setItem("param", JSON.stringify(param));
      this.$router.push({ path: url, query: param });
    },
    // 返回下一步-促销协议
    goNext(id,year) {
      let path = ''
      if(year == 2021){
        path = "/contractManager/NewPromotion";
      }else if (year >= 2022){
        path = "/contractManager/promotionagreement2022";
      }else{
        path = "/contractManager/promotionagreement";
      }
      // let path = "/contractManager/promotionagreement";
      let query = {id: id,year:year,edit:this.params.edit,source:'add'}
      this.jumpTo(path, query);
    },
    // 返回下一步-采购协议
    goNextCX(id) {
      this.sourceOne = false;
      this.sourceTwo = true;
      let path = "/contractManager/purchaseagreement";
      let query = {id: id,edit:this.params.edit}
      this.jumpTo(path, query);
    },
    // 返回列表
    goList() {
      this.$router.push("/contractManager/purchasecontract");
    },
    preview(id,previewOne) {
      if(previewOne == '2'){
        let path = "/contractManager/preview";
        let query = {id:id,previewOne:'2',edit:this.params.edit}
        this.jumpTo(path, query);
      }else if(previewOne == '3'){
        let path = "/contractManager/preview";
        let query = {id:id,previewOne:'3',edit:this.params.edit}
        this.jumpTo(path, query);
      }else if(previewOne == '4'){
        let path = "/contractManager/preview";
        let query = {id:id,previewOne:'4',edit:this.params.edit}
        this.jumpTo(path, query);
      }else if(previewOne == '5'){
        let path = "/contractManager/preview";
        let query = {id:id,previewOne:'5',edit:this.params.edit}
        this.jumpTo(path, query);
      }
    },
  },
  created() {}
};
</script>
<style lang="scss">
.saveDialog {
  .successBtn {
    border-radius: 50%;
    padding: 10px;
    cursor: default;
  }
  .el-icon-check:before {
    font-size: 30px;
  }
  .saveContent {
    text-align: center;
    padding: 30px 0;
    p {
      margin: 15px 0;
    }
  }
}
.colorMsg {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/contractmanagement/purchasecontract/add/dialog/saveResult.vue